<mat-radio-group class="radio-group {{isRadioRow ? '':'radio-group-column'}}" aria-label="field?.controlName" [formGroup]="parentForm" [formControl]="relatedFormControl">
  @for (item of field?.items; track item) {
    <mat-radio-button [style.padding-right]= "buttonPad"
    (change)="handleChange($event)"
    [value]="item.value"
    [checked]="item.selected">{{item.label}}
    </mat-radio-button>
  }
  <mat-error *ngIf="hasError"><div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div></mat-error>
</mat-radio-group>
